import React from 'react';
import WrapperInputGroup from "./WrapperInputGroup";
import PropTypes from "prop-types";
import {MaskInput} from "./MaskInput";
class ImageMaskInput extends React.Component {
    render() {
        return [
                <MaskInput autoFocus={this.props.autoFocus} key="input" input={this.props.input} mask={this.props.mask} onChange={this.props.onChange} onBlur={this.props.onBlur} onFocus={this.props.onFocus}/>,
                (this.props.image.src !== "") ? <img key="image" src={this.props.image.src} alt={this.props.image.alt}/> : null
        ]
    }
}

export const ImageMaskInputGroup = WrapperInputGroup(ImageMaskInput);

ImageMaskInputGroup.propTypes = {
    input: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string,
        disabled: PropTypes.bool,
        required: PropTypes.bool,
        placeholder: PropTypes.string,
    }).isRequired,
    image: PropTypes.shape({
        src: PropTypes.string.isRequired,
        alt: PropTypes.string,
    }),
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/input/base/ImageMaskInputGroup.js